import { render, staticRenderFns } from "./ProduzioneLayout.vue?vue&type=template&id=5e049382&scoped=true&"
import script from "./ProduzioneLayout.vue?vue&type=script&lang=js&"
export * from "./ProduzioneLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProduzioneLayout.vue?vue&type=style&index=0&id=5e049382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e049382",
  null
  
)

export default component.exports